import { render, staticRenderFns } from "./newAdditionalsForm.vue?vue&type=template&id=2ef3c026&"
import script from "./newAdditionalsForm.vue?vue&type=script&lang=js&"
export * from "./newAdditionalsForm.vue?vue&type=script&lang=js&"
import style0 from "./newAdditionalsForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports